<template>
  <fh-container class="text-center">

    <fh-title>{{ consultacapNombre || title }}</fh-title>

    <fh-card>
      <div class="grey--text">
        Debería ser redirigido a la página de {{ consultacapNombre }} prontamente.
      </div>

      <div class="grey--text">
        En caso contrario, puede darle click al botón de abajo.
      </div>

      <v-row justify="center" class="mt-3">
        <v-btn @click="handleClick">
          Volver a Iniciar Sesión
        </v-btn>
      </v-row>
    </fh-card>
  </fh-container>
</template>

<script>
import FhContainer from '@/components/FhContainer'
import FhTitle from '@/components/FhTitle'
import FhCard from '@/components/FhCard'
import { mapActions, mapState } from 'vuex'
import { CONSULTACAP_URL, CONSULTACAP_NOMBRE } from '@/config'
import SessionService from '@/services/SessionService'

export default {
  name: 'Login',
  components: { FhCard, FhTitle, FhContainer },
  data () {
    return {
      title: 'Socio Fernheim',
      valid: true,
      consultacapUrl: CONSULTACAP_URL,
      consultacapNombre: CONSULTACAP_NOMBRE,
    }
  },
  computed: {
    ...mapState('auth', [
      'debeCambiarPin'
    ]),
    query () {
      return this.$route.query
    },
  },
  methods: {
    ...mapActions('auth', [
      'loginToken',
      'unsetCookie',
      'unsetAuth'
    ]),
    async handleLogin () {
      try {
        await this.loginToken([parseInt(this.query.cuenta), SessionService.getToken()])

        if (this.debeCambiarPin) {
          this.$router.push({
            name: 'ChangePin',
            query: { nombre: this.consultacapNombre,  redirect: this.consultacapUrl }
          })
          return
        }

        location.href = this.consultacapUrl
      } catch (e) {
        this.$router.push({ name: 'Login', query: { nombre: this.consultacapNombre,  redirect: this.consultacapUrl } })
      }
    },
    handleClick () {
      this.$router.push({ name: 'Login', query: { nombre: this.consultacapNombre,  redirect: this.consultacapUrl } })
    },
  },
  mounted () {
    this.unsetCookie()
    this.unsetAuth()
    this.handleLogin()
  }
}
</script>

<style scoped>

</style>
